import {
    browserSupportsWebAuthn,
    startAuthentication,
    startRegistration,
} from "@simplewebauthn/browser";
import * as toastr from "toastr";
import LocalStorageAuthorizer from "source/app/infrastructure/Authorizer/LocalStorageAuthorizer";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import Login from "../Login";

export async function RegisterPasskeyAsync(Login: Login) {
    if (!browserSupportsWebAuthn()) {
        toastr.warning("This browser does not support passkeys", "Passkey");
        return false;
    }

    const optionsJSON = await ClientDataProvider.GetPasskeyRegistrationOptions();
    const registrationResponse = await startRegistration({ optionsJSON });

    const verification = await ClientDataProvider.VerifyPasskeyRegistration(
        registrationResponse,
        GetDefaultDeviceName()
    );

    if (!verification.verified) {
        throw new Error("Passkey registration failed");
    }

    toastr.success("Passkey registered", "Passkey");
    return true;
}

export async function LoginWithPasskeyAsync(Login: Login) {
    if (!browserSupportsWebAuthn()) {
        toastr.warning("This browser does not support passkeys", "Passkey");
        return;
    }

    const username = Login.state.username;

    if (!username) {
        toastr.warning("Please enter your username first", "Passkey login");
        return;
    }

    try {
        Login.setState({ isPasskeyActionInProgress: true });

        const optionsJSON = await ClientDataProvider.GetPasskeyLoginOptions(
            username
        );
        const authenticationResponse = await startAuthentication({
            optionsJSON,
        });

        const verification = await ClientDataProvider.VerifyPasskeyLogin(
            username,
            authenticationResponse
        );

        if (!verification.verified) {
            throw new Error("Passkey login failed");
        }

        LocalStorageAuthorizer.SignIn(username);
    } catch (error) {
        toastr.error(error.message, "Passkey login error");
    } finally {
        Login.setState({ isPasskeyActionInProgress: false });
    }
}

function GetDefaultDeviceName() {
    const platform = window.navigator.platform || "device";
    return `${platform} passkey`;
}
